import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

const TIGGER_TEXT_BOTTOM_BORDER = "1px";

export const TriggerTextContainer = styled(Text)<{ hideBorder?: boolean }>`
    display: inline-block;
    border-bottom: ${({ hideBorder = false, theme }) =>
        hideBorder ? "none" : `${TIGGER_TEXT_BOTTOM_BORDER} dashed ${theme.colors.light.text_Med_Emphasis}`};
    margin-left: ${props => props.theme.spacing.xxSmall};
`;
